import {ENInviteStatus} from '../../enums';


export class SOPutOrganizationInvite {

  constructor(
    public uid: string,
    public status: ENInviteStatus = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutOrganizationInvite(
      'uid' in params ? params.uid : null,
      'status' in params ? params.status : null,
    );
  }
}
